import { createApiRef } from '@backstage/core-plugin-api';





/**
 * ApiRef for the AgentApi.
 *
 * @public
 */
export const accessControlApiRef = createApiRef({
  id: 'plugin.accesscontrol.api',
});








